export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDkgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTcuODg2NzIgNy4wNzMyNEw4LjI5Mjk3IDcuNDgwNDdMMS40MDYyNSAxNC4zNjYyTDAuNTkzNzUgMTMuNTUzN0w2LjY2NjAyIDcuNDc5NDlMMC41OTM3NSAxLjQwNjI1TDEuNDA2MjUgMC41OTM3NUw3Ljg4NjcyIDcuMDczMjRaIiBmaWxsPSIjNTM2MjhCIi8+CiAgPC9zdmc+CiAg"


//////////////////
// WEBPACK FOOTER
// ./images/mobile-children.svg
// module id = 148
// module chunks = 0